<template>
  <div id="app">
    <div class="header">
      <div class="headercontent" @click.self="gobackhomepage">
        <div class="login" v-if="admindatatf == true">
          <a href="#" @click.stop="login">登录</a>
          <span>|</span>
          <a href="#" @click.stop="torei">注册</a>
        </div>
        <el-col :span="12">
          <el-dropdown
            trigger="click"
            class="admindata"
            v-if="admindatatf == false"
          >
            <span class="el-dropdown-link">
              <img :src="adminaxinxi.HeadImg" alt="" /><span class="username">{{
                adminaxinxi.UserName
              }}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><span @click="toadmin" class="adminspan"
                  >个人中心</span
                ></el-dropdown-item
              >
              <el-dropdown-item
                ><span @click="outadmin" class="adminspan"
                  >退出登录</span
                ></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </div>
      <div
        class="phoneheadercontent"
        v-if="url != 'phonelogin' && url != 'phonezhuce' && headshow == true"
      >
        <el-dropdown trigger="click" class="moreimgbox">
          <span class="el-dropdown-link">
            <img
              src=".././public/phone/切图/03-icon-更多操作.png"
              alt=""
              v-if="url === ''"
              class="moreimg"
              @click="moreimg"
            />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><span
                @click="tophonelogin"
                class="adminspan"
                v-if="admindatatf == true"
                >登录</span
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><span @click="tophonezhuce" class="adminspan"
                >注册</span
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><span
                @click="toadmin"
                class="adminspan"
                v-if="admindatatf == false"
                >个人中心</span
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><span
                @click="outadmin"
                class="adminspan"
                v-if="admindatatf == false"
                >退出登录</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <img
          src=".././public/phone/切图/03-icon-关闭.png"
          alt=""
          v-if="url != ''"
          @click="gobackho"
          class="goback"
        />
      </div>
    </div>
    <router-view class="body"></router-view>
    <div class="footbottom">
      <span>版权所有：南京农业大学</span>
      <span>技术支持：南京先极科技有限公司</span>
    </div>
    <!-- 登录弹框 -->
    <el-dialog
      title=""
      :visible.sync="dialogFormVisible"
      @close="closeUserINfoForm"
    >
      <h2>欢迎登录</h2>
      <span class="logintext">南京农业大学虚拟仿真实验教学共享平台</span>
      <img
        src=".././public/pc/02-icon-close.png"
        alt=""
        class="close"
        @click="closelogin"
      />
      <el-form :model="form">
        <el-form-item label="">
          <img src=".././public/pc/02-icon-用户名.png" alt="" />
          <el-input
            v-model="ruleForm.UserAccount"
            autocomplete="off"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <img src=".././public/pc/02-icon-密码.png" alt="" />
          <el-input
            v-model="ruleForm.Password"
            autocomplete="off"
            placeholder="请输入密码"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="vueloginbox">
          <img src=".././public/pc/02-icon-验证码.png" alt="" />
          <el-input
            v-model="codenum"
            autocomplete="off"
            placeholder="请输入验证码"
            @keyup.enter.native="tologin"
          ></el-input>
          <div class="shuaxinbox" @click="shuaxin">
            <Sidentify :identifyCode="identifyCode" class="code" />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tologin" class="tologin"> 立即登录</el-button>
        <!-- <a href="https://authserver.njau.edu.cn/authserver/login?service=http://vlab.njau.edu.cn/njnydx_xnfz/CasLogin.aspx" target="_blank" class="identity"> 统一身份验证登录 </a> -->
        <el-button @click="tysfrz" type="primary" class="identity"
          >统一身份验证登录</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sidentify from "./utils/Sidentify.vue";
import { login } from "@/api/login";
import { getadmin } from "@/api/admin";
export default {
  components: {
    Sidentify,
  },
  name: "App",
  data() {
    return {
      headshow: true,
      UserRoleName: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      admindatatf: false,
      admindata: "",
      moreboxnum: false,
      showclass: true,
      dialogFormVisible: false,
      form: {
        url: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      url: "",
      ruleForm: {
        UserAccount: "",
        Password: "",
      },
      codenum: "",
      admindataxinxi: {
        UserAccount: "",
      },
      adminaxinxi: {},
    };
  },
  methods: {
    // 返回首页
    gobackhomepage() {
      this.$router.push("/");
    },
    // 点击关闭首页头
    closetop() {
      this.headshow = false;
    },
    // 点击退出
    outadmin() {
      this.moreboxnum = false;
      sessionStorage.removeItem("UserToken"), this.$router.push({ query: {} });
      location.reload();
    },
    // 刷新验证码
    shuaxin() {
      this.refreshCode();
    },
    // 获取用户信息
    togetadmin(data) {
      getadmin(data).then((res) => {
        if (res.code === 0) {
          this.adminaxinxi = res.UserInfo;
        }
      });
    },
    // 刷新页面
    load() {},
    gobackho() {
      this.$router.push("/");
    },
    // 点击跳转手机登录
    tophonelogin() {
      (this.moreboxnum = false), this.$router.push("phonelogin");
    },
    // 点击跳转手机注册
    tophonezhuce() {
      (this.moreboxnum = false), this.$router.push("phonezhuce");
    },
    // 点击打开登录
    moreimg() {
      this.moreboxnum = !this.moreboxnum;
    },
    // 点击跳转注册页
    torei() {
      this.$router.push("register");
    },
    // 点击登录
    login() {
      this.dialogFormVisible = true;
      this.shuaxin();
    },
    // 点击跳转个人中心
    toadmin() {
      this.moreboxnum = false;
      console.log(1);
      if (this.UserRoleName != "学生" || !this.UserRoleName) {
        // sessionStorage.setItem("succ", "跳转成功");
        // window.open('http://192.168.106.218:1012/njnydx_xnfz/index.aspx?UserToken=' + sessionStorage.getItem('UserToken'), "_blank")
        //本地
        // window.open('http://192.168.106.218:9091/njnydx_xnfz/LoginFree.aspx?UserToken=' + sessionStorage.getItem('UserToken'), "_self");
        //学校
        // window.open('https://vlab.njau.edu.cn/njnydx_xnfz/LoginFree.aspx?UserToken=' + sessionStorage.getItem('UserToken'), "_self");
        window.open(
          "http://vlab.njau.edu.cn/njnydx_xnfz/LoginFree.aspx?UserToken=" +
            sessionStorage.getItem("UserToken"),
          "_self"
        );
      } else {
        // sessionStorage.setItem("diff", "跳转失败");
        this.$router.push("admin");
      }
    },
    // 关闭登录
    closelogin() {
      this.dialogFormVisible = false;
    },
    // 获取地址栏
    geturl() {
      var urlStr = location.href;
      var index = urlStr.lastIndexOf("/");
      this.url = urlStr.substring(index + 1, urlStr.length);
    },
    // 点击登录
    // tologin() {
    //   if (this.codenum == this.identifyCode) {
    //     sessionStorage.setItem("UserAccount", this.ruleForm.UserAccount);
    //     console.log(this.ruleForm);
    //     login(this.ruleForm).then((res) => {
    //       console.log(res);
    //       if (res.code === 0) {
    //         this.$message.success("登录成功");
    //         sessionStorage.setItem("UserAccount", res.UserInfo.UserAccount);
    //         sessionStorage.setItem("UserType", res.UserInfo.UserType);
    //         sessionStorage.setItem("UserToken", res.UserInfo.UserToken);
    //         sessionStorage.setItem("UserRoleName", res.UserInfo.UserRoleName);
    //         location.reload();
    //         this.dialogFormVisible = false;
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     });
    //   } else {
    //     this.$message.error("验证码错误");
    //   }
    //   this.shuaxin();
    // },

    // 点击登录
    tologin() {
      if (this.codenum == this.identifyCode) {
        sessionStorage.setItem("UserAccount", this.ruleForm.UserAccount);
        login(this.ruleForm).then((res) => {
          console.log(res);
          if (res.code === 0) {
            this.$message.success("登录成功");
            sessionStorage.setItem("UserAccount", res.UserInfo.UserAccount);
            sessionStorage.setItem("UserType", res.UserInfo.UserType);
            sessionStorage.setItem("UserToken", res.UserInfo.UserToken);
            sessionStorage.setItem("UserRoleName", res.UserInfo.UserRoleName);
            this.dialogFormVisible = false;
            this.UserRoleName = res.UserInfo.UserRoleName;
            this.admindata = res.UserInfo.UserToken;
            this.admindatatf = false;
            this.togetadmin({ UserToken: this.admindata });
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("验证码错误");
      }
      this.shuaxin();
    },

    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    closeUserINfoForm() {
      this.ruleForm.UserAccount = "";
      this.ruleForm.Password = "";
      this.codenum = "";
    },
    // 统一身份认证
    tysfrz() {
      window.open(
        // "https://authserver.njau.edu.cn/authserver/login?service=http://vlab.njau.edu.cn/njnydx_xnfz/CasLogin.aspx",
        "https://authserver.njau.edu.cn/authserver/login?service=https://vlab.njau.edu.cn/tyrz/CasLogin.aspx",
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
  beforeCreate() {},
  created() {
    this.geturl();
    this.url = location.href;
    this.UserRoleName = sessionStorage.getItem("UserRoleName");
    this.admindata = sessionStorage.getItem("UserToken");
    this.admindataxinxi.UserToken = sessionStorage.getItem("UserToken")
      ? sessionStorage.getItem("UserToken")
      : this.$route.query.UserToken;
    this.admindatatf = this.admindata == null;
    //初始化验证码
    this.refreshCode();
    this.togetadmin(this.admindataxinxi);
  },
  watch: {
    $route(to, from) {
      this.geturl();
    },
  },
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

li {
  list-style: none;
}

#app {
  width: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  @media only screen and (max-width: 767px) {
    background-image: url(.././public/phone/切图/bg.png);
    background-color: #068358;
    background-size: cover;
  }

  @media only screen and (min-width: 768px) {
    background-image: url(.././public/pc/bg.png);
    background-color: #f8f9fc;
    background-size: contain;
  }

  background-position: top center;
  background-repeat: no-repeat;
  min-height: 100vh;
}

#app .body {
  @media only screen and (max-width: 767px) {
    min-height: 76vh;
  }

  @media only screen and (min-width: 768px) {
    min-height: 100vh;
  }
}

.shownoshow {
  display: none;
}

.header {
  width: 100%;

  @media only screen and (max-width: 767px) {
    height: 25vw;
  }

  @media only screen and (min-width: 768px) {
    height: 150px;
  }
}

.moremethods {
  @media only screen and (max-width: 767px) {
    right: 15px;
    top: 65px;
  }

  @media only screen and (min-width: 768px) {
    right: 10px;
    top: 40px;
  }

  display: flex;
  position: absolute;

  background-color: #fff;
  flex-direction: column;

  border-radius: 10px;
  box-shadow: #999 0 0 10px;
  z-index: 11;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 0;
  transition: all 0.3s;

  span {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    color: #068358;
    font-weight: bold;
  }
}

.moremethodsshow {
  height: 123px !important;
}

#app .el-form-item__content .code {
  height: 40px;
  position: absolute;
  top: 0;
  transform: translateX(-100%);
  left: 100%;
}

.phoneheadercontent {
  position: relative;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(.././public/phone/切图/top@3x.png);

  @media only screen and (max-width: 767px) {
    display: block;
  }

  @media only screen and (min-width: 768px) {
    display: none;
  }

  position: relative;
  width: 100%;

  .goback {
    width: 10%;
  }

  .moreimgbox {
    position: absolute;
    right: 5%;
    top: 10%;
    width: 10%;
    display: flex;

    > span {
      width: 100%;
      height: 50px;
    }

    img {
      width: 100%;
    }
  }

  img {
    position: absolute;
    right: 5%;
    top: 15%;
    width: 7%;
  }
}

.el-dropdown-link {
  display: flex;
  align-items: center;
}

.admin {
  display: flex;
  color: #fff;
  position: absolute;
  right: 20px;
  top: 55px;
  align-items: center;

  img {
    margin: 0 10px;
  }
}

.admindata {
  display: flex;
  align-items: center;
  color: #fff;
  position: absolute;
  right: 20px;
  top: 55px;
  cursor: pointer;

  img {
    margin: 0 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
}

.headercontent {
  position: relative;
  width: 1200px;
  margin: auto;
  height: 100%;
  background-image: url(.././public/pc/title.png);

  @media only screen and (max-width: 767px) {
    display: none;
  }

  @media only screen and (min-width: 768px) {
    display: block;
  }

  background-repeat: no-repeat;
  background-position: center 50%;
  background-size: contain;
}

.login {
  width: 100px;
  position: absolute;
  right: 20px;
  z-index: 12;
  top: 60px;
  font-size: 16px;
  font-family: "微软雅黑";
  color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.el-dropdown-menu__item {
  padding: 0 !important;
}

.login > a {
  color: #fff;
}

.login > a:nth-child(1):hover {
  color: #ffff;
}

.login > span {
  font-size: 12px;
}

.adminspan {
  width: 100%;
  padding: 0 20px;
  display: block;
}

.adminspan:hover {
  color: #068358;
}

/* 登录框 */
.logintext {
  color: #333;
  font-weight: bold;
  padding-bottom: 10px;
  display: block;
  font-size: 18px;
  margin-bottom: 32px;
  border-bottom: 1px solid rgb(226, 226, 226);
}

#app .el-dialog__body > .el-form {
  padding: 0 61px !important;
}

.el-form-item {
  margin-bottom: 15px;
}

#app .el-dialog__body > .el-form input {
  background-color: #f3f7f6;
  border: 1px solid #daf7ec;
  color: #96b7af;
  font-size: 18px;
  padding-left: 50px;
}

#app .el-dialog__body > .el-form input::placeholder {
  color: #6da18f;
  opacity: 0.5;
}

#app .el-dialog {
  width: 500px;
  position: relative;
  border-radius: 15px;
  background-image: url(.././public/pc/02-LOGIN.png);
  background-repeat: no-repeat;
  background-position: center 5%;
}

#app .el-dialog .close {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

#app .el-dialog__body {
  padding-bottom: 15px;
}

#app .dialog-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#app .el-dialog__footer {
  padding-top: 0px;
  padding-bottom: 45px;
}

#app .tologin {
  background-color: #068358;
  color: #fff;
  height: 50px;
  font-size: 18px;
}

#app .identity {
  background-color: transparent;
  color: #068358;
  height: 50px;
  font-size: 18px;
  box-sizing: border-box;
  border: #068358 2px solid;
}

#app .dialog-footer button {
  width: 338px;
  margin: 5px 0;
}

#app .el-dialog h2 {
  color: #068358;
  margin-bottom: 10px;
}

#app .el-form-item__content {
  position: relative;
}

#app .el-form-item__content img {
  position: absolute;
  z-index: 11;
  left: 20px;
  top: 10px;
}

#app .el-dialog__header {
  padding: 0 !important;
}

.footlink > ul {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
}

.footlink > ul > li {
  display: flex;
  width: 19.2%;
  flex-direction: column;
  color: #8891a8;
  font-size: 15px;
}

.footlink > ul > li > img {
  width: 100%;
  margin-bottom: 10px;
}

.footbottom {
  padding: 30px 0;
  width: 100%;
  height: 50px;
  background-color: #068358;
  display: flex;
  color: #fff;
  font-size: 14px;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
}

.footbottom > span {
  margin: 0 15px;
}

.vueloginbox .s-canvas {
  height: 100%;
}

.username {
  width: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.vueloginbox .s-canvas canvas {
  border: 2px solid rgb(214, 214, 214);
  height: 100%;
  box-sizing: border-box;
}

// .el-popper{
//   left: 283px!important;
// }
#app .el-dialog__body > .el-form input:focus {
  border-color: #068358;
}
</style>



// WEBPACK FOOTER //
// src/App.vue